module.exports = __webpack_public_path__ + "static/media/nu.48261860.svg";